import { Image, ImageProps } from '@chakra-ui/react';
import { useTheme } from '../../contexts/ThemeProvider';

export function Logo(props: ImageProps) {
  const { logo } = useTheme();
  return <Image src={logo} width={'200px'} {...props} />;
}
